import { RootState } from "store/reducers/main";
import { ChannelFeaturesEnum } from "types/working-model";

export const selectCurrentChannel = (state: RootState) => state.AuthReducer.channels.find(
	channel => channel.channel === state.AuthReducer.user?.active_channel as number
);

export const selectChannelFlag = (flag: ChannelFeaturesEnum) => {
	return (state: RootState) => selectCurrentChannel(state)?.enabled_features?.includes(flag) || false;
};

export const selectMuxDrmEnabled = () => selectChannelFlag(ChannelFeaturesEnum.mux_drm);
export const selectCoursesEnabled = () => selectChannelFlag(ChannelFeaturesEnum.courses);